// 入力画面のグリッド用 ref(データ/列定義/API)のキー解決とアクセサをまとめる。
// 加工指示・品番マスタで同一実装のため共有する。
export function createGridRefAccessors(deps) {
    const {
        isEmpty,
        DicVal,
        createRef,
        fnc,
        griddataRefs,
        gridcolRefs,
        gridapiRefs,
        gridcolapiRefs,
        filterGridColDef
    } = deps;

    // gridindex が解決できないパネル向けの代替キーを作る。
    function gridRefFallbackKey(panel) {
        if (isEmpty(panel)) return '__grid_ref_unknown__';
        if (typeof panel !== 'object') return '__grid_ref__' + String(panel);
        const id = String(DicVal(panel, 'id', '')).trim();
        const type = String(DicVal(panel, 'type', '')).trim();
        return '__grid_ref__' + id + '_' + type;
    }
    function ensureGridRef(refArray, panel, initializer) {
        const hasGridIndex = !isEmpty(fnc.current) && typeof fnc.current.gridindex === 'function';
        const gidx = hasGridIndex ? fnc.current.gridindex(panel) : -1;
        const refKey = gidx === -1 ? gridRefFallbackKey(panel) : gidx;
        if (isEmpty(refArray.current[refKey])) {
            refArray.current[refKey] = initializer();
        }
        return refArray.current[refKey];
    }
    function ensureGridDataRef(panel) {
        return ensureGridRef(griddataRefs, panel, () => createRef());
    }
    function ensureGridColRef(panel) {
        return ensureGridRef(gridcolRefs, panel, () => createRef());
    }
    function ensureGridApiRef(panel) {
        return ensureGridRef(gridapiRefs, panel, () => createRef());
    }
    function ensureGridColApiRef(panel) {
        return ensureGridRef(gridcolapiRefs, panel, () => createRef());
    }
    function SetGridData(panel, data) {
        const ref = ensureGridDataRef(panel);
        if (isEmpty(ref)) return;
        ref.current = data;
    }
    function GridData(panel) {
        const ref = ensureGridDataRef(panel);
        if (isEmpty(ref)) return null;
        return ref.current;
    }
    // 列定義は画面固有の絞り込み(明細ヘッダ項目の除外など)を通してから保持する。
    function SetGridColDef(panel, coldef) {
        const ref = ensureGridColRef(panel);
        if (isEmpty(ref)) return;
        ref.current = typeof filterGridColDef === 'function' ? filterGridColDef(panel, coldef) : coldef;
    }
    function SetGridApi(panel, api) {
        const ref = ensureGridApiRef(panel);
        if (isEmpty(ref)) return;
        ref.current = api;
    }
    function GridApi(panel) {
        const ref = ensureGridApiRef(panel);
        if (isEmpty(ref)) return null;
        return ref.current;
    }
    function SetGridColApi(panel, api) {
        const ref = ensureGridColApiRef(panel);
        if (isEmpty(ref)) return;
        ref.current = api;
    }
    function GridColApi(panel) {
        const ref = ensureGridColApiRef(panel);
        if (isEmpty(ref)) return null;
        return ref.current;
    }

    return {
        gridRefFallbackKey,
        ensureGridRef,
        ensureGridDataRef,
        ensureGridColRef,
        ensureGridApiRef,
        ensureGridColApiRef,
        SetGridData,
        GridData,
        SetGridColDef,
        SetGridApi,
        GridApi,
        SetGridColApi,
        GridColApi
    };
}
